<template>
  <div class="bg-gray-100 min-h-screen flex items-center justify-center">
    <!-- Coming Soon Section -->
    <div class="text-center">
      <h1 class="text-4xl font-bold text-green-700 mb-4">Coming Soon</h1>
      <p class="text-gray-700 text-lg">We are working hard to bring this feature to you. Stay tuned for updates!</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "ComingSoon",
};
</script>

<style scoped>
/* Custom styles if needed */
</style>
